import { UPDATE_COUNTRY, UPDATE_CITY, UPDATE_STORE } from '../actions/types.js';

const INITIAL_STATE = {
    country: null,
    city: null,
    store: null,
    countries: [
        'Germany'
    ],
    cities: [
        'Munich'
    ],
    stores: [
        'adidas Store München, Sendlinger Strasse 10, 80331, DE'
    ],
};

const page1 = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case UPDATE_COUNTRY:
            return { 
                ...state, 
                country: action.payload.country,
            }
        case UPDATE_CITY:
            return { 
                ...state, 
                city: action.payload.city,
            }
        case UPDATE_STORE:
            return { 
                ...state, 
                store: action.payload.store,
            }
        default:
            return state;
    }
}

export default page1

